<script>
import RelatedProjectItem from '../../RelatedProjects/RelatedProjectItem/index.vue'
import { resizeImage } from '~/util/img.util'
export default {
  components: {
    RelatedProjectItem
  },
  props: {
    projectList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      relatedProject: [],
      isLoading: false,
      isLastPage: false,
      isBigScreen: true,
      imageWidth: 0,
      imageHeight: 0
    }
  },
  mounted() {
    this.getImageWidthAndHeight()
    this.resizeProjectImagee()
  },
  methods: {
    resizeProjectImagee,
    getImageWidthAndHeight
  }
}

function getImageWidthAndHeight() {
  if (this.$_thebox.clientWidth > 940) {
    this.isBigScreen = true
    this.imageWidth = (this.$_thebox.clientWidth * 0.8 - 22) / 3
    this.imageHeight = (this.imageWidth / 7) * 5
  } else {
    this.isBigScreen = false
    this.imageWidth = (this.$_thebox.clientWidth - 30) / 2
    this.imageHeight = (this.imageWidth / 7) * 5
  }
}

function resizeProjectImagee() {
  const list = this.projectList.map((item) => {
    const project = Object.assign({}, item)
    if (project.projectImgOssUrl) {
      project.projectImgOssUrl = resizeImage({
        src: project.projectImgOssUrl,
        width: this.imageWidth,
        height: this.imageHeight
      })
    } else {
      project.projectImgOssUrl = resizeImage({
        src: this.defaultProjectImg,
        width: this.imageWidth,
        height: this.imageHeight
      })
    }
    return project
  })
  this.$emit('update:projectList', list)
}
</script>
<template>
  <ul class="home_page_project_container">
    <li v-for="(project, index) in projectList" :key="index">
      <nuxt-link :to="`project/${project.projectId}`" :target="$_newtab" append>
        <div class="single_home_page_project_container">
          <!-- 单个item -->
          <RelatedProjectItem :project-item="project" />
        </div>
      </nuxt-link>
    </li>
  </ul>
</template>
<style lang="scss">
.home_page_project_container {
  list-style: none;
}

.gs_one_line {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media screen and (min-width: 940px) {
  .home_page_project_container {
    // border: 1px solid red;

    li {
      font-size: 14px !important;
      display: inline-block;
      width: calc((100%) / 3);
    }
  }

  .single_home_page_project_container {
    padding-right: 15px;
    padding-bottom: 30px;
  }
}

@media screen and (max-width: 940px) {
  .home_page_project_container {
    // border: 1px solid red;
    .single_home_page_project_container {
      padding-top: 20px;
      display: flex;
      align-items: center;
      .top_container {
        .icon_container {
          .icon_video {
            width: 17px;
            height: 17px;
            margin-left: 5px;
          }
          .icon_vr {
            width: 17px;
            height: 17px;
            margin-left: 5px;
          }
        }
        span {
          width: 36px;
          height: 16px;
          text-align: center;
          line-height: 18px;
          font-size: 12px;
          padding: 0px;
          top: 10px;
          left: 10px;
        }
      }
    }
    .project_title {
      font-size: 16px !important;
    }

    li {
      display: inline-block;
      width: calc((100% - 30px) / 2);
      margin-right: 15px;
    }
    ul {
      li {
        margin-right: 0px;
      }
    }
  }
}

.single_home_page_project_container {
  border-radius: 5px;
  // border: 1px solid blue;
  * {
    margin: 0;
    padding: 0;
  }

  .img_mark_container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  display: flex;
  flex-direction: column;
  // border: 1px solid red;

  .project_title {
    font-size: 18px;
    color: rgba(0, 0, 0, 1);
    line-height: 18px;
    padding-top: 15px;
    padding-bottom: 10px;
  }

  .top_container {
    position: relative;

    .icon_container {
      bottom: 11px;
      display: flex;
      position: absolute;
      margin-left: 5px;

      %icon_common {
        width: 30px;
        height: 30px;
        margin-left: 10px;
      }
      .icon_video {
        @extend %icon_common;
        left: 15px;
      }

      .icon_vr {
        @extend %icon_common;
        left: 55px;
      }
    }

    span {
      position: absolute;
      display: inline-block;
      font-size: 16px;
      color: rgba(42, 42, 42, 1);
      line-height: 16px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 2px;
      top: 15px;
      left: 15px;
      padding: 4px 10px;
    }

    .project_image {
      width: 100%;
      border-radius: 5px;
    }
  }

  ul {
    li {
      display: inline !important;
      list-style: none !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      color: rgba(68, 68, 68, 1) !important;
      line-height: 12px !important;
    }
  }
}
</style>
